/*
 * Design preview for the detail-page status chips and bars — every entry of DETAIL_STATUS /
 * DETAIL_STATUS_BAR on one screen, at /dev/status-chips. Use it to check icons and colours after
 * changing src/common/DetailStatusChip.jsx; it lists new entries automatically.
 */
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { DETAIL_STATUS, DETAIL_STATUS_BAR, DetailStatusBar, DetailStatusChip } from '../../common/DetailStatusChip';

const Row = ({ name, children }) => (
    <Stack direction="row" alignItems="center" gap={3} sx={{ py: 1.5, borderBottom: '1px solid #eee' }}>
        <Typography sx={{ width: 260, flexShrink: 0, fontFamily: 'monospace', fontSize: 13, color: 'rgba(0,0,0,0.6)' }}>{name}</Typography>
        <Box sx={{ flex: 1 }}>{children}</Box>
    </Stack>
);

const StatusChipPreview = () => (
    <Box sx={{ p: 4, bgcolor: 'white', minHeight: '100%' }}>
        <Typography variant="h4" mb={1}>
            Detail status chips — preview
        </Typography>
        <Typography color="text.secondary" mb={3}>
            Design preview. Source of truth: src/common/DetailStatusChip.jsx (DETAIL_STATUS / DETAIL_STATUS_BAR).
        </Typography>

        <Typography variant="h6" mt={2}>
            Chips
        </Typography>
        {Object.entries(DETAIL_STATUS).map(([key, status]) => (
            <Row key={key} name={`DETAIL_STATUS.${key}`}>
                {/* Chips that link to another document on real pages are clickable here too (hover + pointer). */}
                <DetailStatusChip status={status} onClick={['WORK_ORDER', 'INVOICED'].includes(key) ? () => {} : undefined} />
            </Row>
        ))}

        <Typography variant="h6" mt={4}>
            Bars
        </Typography>
        {Object.entries(DETAIL_STATUS_BAR).map(([key, status]) => (
            <Row key={key} name={`DETAIL_STATUS_BAR.${key}`}>
                <DetailStatusBar status={status} />
            </Row>
        ))}

        <Typography variant="h6" mt={4}>
            As shown on pages
        </Typography>
        <Row name="Work order — Invoiced">
            <Stack direction="row" gap={2}>
                <DetailStatusChip status={DETAIL_STATUS.AUTHORIZED} />
                <DetailStatusChip status={DETAIL_STATUS.INVOICED} onClick={() => {}} />
            </Stack>
        </Row>
        <Row name="Estimate — Sent + Work Order">
            <Stack direction="row" gap={2}>
                <DetailStatusChip status={DETAIL_STATUS.SENT} />
                <DetailStatusChip status={DETAIL_STATUS.WORK_ORDER} onClick={() => {}} />
            </Stack>
        </Row>
        <Row name="Invoice — Sent + payment">
            <Stack direction="row" gap={2} flexWrap="wrap">
                <DetailStatusChip status={DETAIL_STATUS.SENT} />
                <DetailStatusChip status={DETAIL_STATUS.BALANCE_REMAINING} label="Balance Remaining: $120.00" />
                <DetailStatusChip status={DETAIL_STATUS.GOOGLE_REVIEW_REQUESTED} />
            </Stack>
        </Row>
    </Box>
);

export default StatusChipPreview;
